var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2673_19314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.587969 6.31958H28.0875L30.8813 15.2597V20.0796H26.1346V19.1196H29.9213V15.4062L27.3817 7.27958H1.54797V19.1196H5.86797V20.0796H0.587969V6.31958ZM10.1346 19.1196H21.868V20.0796H10.1346V19.1196Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7867 13.2001V6.8001H12.7467V13.2001H11.7867ZM15.52 13.2001V6.8001H16.48V13.2001H15.52ZM22.9867 13.2001V6.8001H23.9467V13.2001H22.9867ZM13.92 19.6001V13.2001H14.88V19.6001H13.92ZM17.6533 19.6001V13.2001H18.6133V19.6001H17.6533Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3213 12.7196V6.79958H5.2813V12.7196H29.868V13.6796H1.06797V12.7196H4.3213Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00052 20.773C8.94309 20.773 9.70719 20.0089 9.70719 19.0664C9.70719 18.1238 8.94309 17.3597 8.00052 17.3597C7.05795 17.3597 6.29385 18.1238 6.29385 19.0664C6.29385 20.0089 7.05795 20.773 8.00052 20.773ZM8.00052 21.733C9.47328 21.733 10.6672 20.5391 10.6672 19.0664C10.6672 17.5936 9.47328 16.3997 8.00052 16.3997C6.52776 16.3997 5.33385 17.5936 5.33385 19.0664C5.33385 20.5391 6.52776 21.733 8.00052 21.733Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0005 20.773C24.9431 20.773 25.7072 20.0089 25.7072 19.0664C25.7072 18.1238 24.9431 17.3597 24.0005 17.3597C23.058 17.3597 22.2939 18.1238 22.2939 19.0664C22.2939 20.0089 23.058 20.773 24.0005 20.773ZM24.0005 21.733C25.4733 21.733 26.6672 20.5391 26.6672 19.0664C26.6672 17.5936 25.4733 16.3997 24.0005 16.3997C22.5278 16.3997 21.3339 17.5936 21.3339 19.0664C21.3339 20.5391 22.5278 21.733 24.0005 21.733Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9331 24.4002H30.3997V25.4669H14.9331V24.4002ZM10.6664 27.0669H21.8664V28.1336H10.6664V27.0669Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.20208 24.4002H12.2646V25.4669H-3.20208V24.4002ZM-7.46875 27.0669H3.73125V28.1336H-7.46875V27.0669Z",
    fill: "#F6931E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2673_19314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.56e2c8452cec71450bafea1b14c4fbd6.svg";
export { ForwardRef as ReactComponent };